export enum TriggerType {
  Insurance = 'insurance',
  ColdChain = 'cold_chain',
  ControlledSubstance = 'controlled_substance',
  SpecialtyMedication = 'specialty_medication',
}

export interface ISignatureRequirement {
  id: number;
  name: string;
  customer_id: number;
  trigger_type: TriggerType;
  insurance_bin?: string | null;
  insurance_pcn?: string | null;
  insurance_group?: string | null;
  created_by: number;
  created_ts: string;
  updated_by: number;
  updated_ts: string;
}

export interface ICreateSignatureRequirementRequest {
  name: string;
  customer_id: number;
  trigger_type: TriggerType;
  insurance_bin?: string;
  insurance_pcn?: string;
  insurance_group?: string;
}

// API returns a flat array — no server-side pagination (confirmed: max ~10 rules per customer).
// UI-level pagination is optional and can be implemented client-side if desired.
export type ISignatureRequirementListResponse = ISignatureRequirement[];

// trigger_type accepts a single value when exactly one type is selected in the UI.
// When "all" or multiple types are selected, omit trigger_type — API returns all rules.
// See Challenge 5 for the full debounce/refetch strategy.
export interface IListFilters {
  search?: string;
  trigger_type?: string;
}

export interface IGroupedSignatureRequirement {
  triggerType: TriggerType;
  children: ISignatureRequirement[];
  createdBy: string;
  lastModified: string;
}
